module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page-xi"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('ol', {
    staticClass: "none",
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "cover"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "titlepage"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/titlepage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "toc-copyright"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-part",
    attrs: {
      "id": "toc-part001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/part001"
    }
  }, [_vm._v("Book I: O Canada")]), _vm._v(" "), _c('ol', {
    staticClass: "none"
  }, [_c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_vm._v("One")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_vm._v("Two")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-part",
    attrs: {
      "id": "toc-part002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book II: Pay the Piper")]), _vm._v(" "), _c('ol', {
    staticClass: "none"
  }, [_c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-part",
    attrs: {
      "id": "toc-part003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book III: Should Auld Acquaintance Be Forgot")]), _vm._v(" "), _c('ol', {
    staticClass: "none"
  }, [_c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter009a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter009a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-part",
    attrs: {
      "id": "toc-part004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book IV: Enemy Without, Enemy Within")]), _vm._v(" "), _c('ol', {
    staticClass: "none"
  }, [_c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-part",
    attrs: {
      "id": "toc-part005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book V: The Gang’s All Here")]), _vm._v(" "), _c('ol', {
    staticClass: "none"
  }, [_c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter016"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter017"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "Ref_82016a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Extras")]), _vm._v(" "), _c('ol', {
    staticClass: "none"
  }, [_c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-personblurb"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/personblurb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meet the Author")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-ad-card"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/adcard"
    }
  }, [_vm._v("By Mira Grant")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-teaser001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/teaser001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Preview of "), _c('em', [_vm._v("Into the Drowning Deep")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-appendix",
    attrs: {
      "id": "toc-appendix001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About Orbit Short Fiction")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-appendix",
    attrs: {
      "id": "Newsletters"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/newsletterOrbit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orbit Newsletter")])])])]), _vm._v(" "), _c('nav', {
    staticClass: "hidden-tag",
    attrs: {
      "epub:type": "landmarks",
      "hidden": "hidden"
    }
  }, [_c('h1', [_vm._v("Navigation")]), _vm._v(" "), _c('ol', {
    staticClass: "none",
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/chapter001"
    }
  }, [_vm._v("Begin Reading")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/toc"
    }
  }, [_vm._v("Table of Contents")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 66
// module chunks = 0